import React from "react";
import leftImage from "../../assets/icons/PrivacyPolicy_LeftImg.png";
import rightImage from "../../assets/icons/PrivacyPolicy_RightImg.png";
import { styled } from "@mui/system";

const Container = styled('section')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0vw 5vw 2vw;
  position: relative;
  background: transparent;

  min-height: 85vh;
  height: 100%; 

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 15px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.1), transparent);
  }

  @media (max-width: 768px) {
    padding: 5vw 2vw; 
    min-height: 20vh;
    
    &::after {
      height: 20px;
      bottom: -10px; 
    }
  }
`;
const LeftSection = styled('div')`
  position: relative;
  width: 50%;
  height: 100%;
`;

const BackgroundImage = styled('img')`
  width: 80%;
  height: auto
  object-fit: contain; 
  @media (max-width: 768px) {
    margin-left: 20px;
  }
`;

const Title = styled('span')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  font-weight: 600;
  font-family:Montserrat;
  color: #414042;
  font-size:4.125rem;/*66px */
  white-space: nowrap;
  @media (max-width: 1280px) {
    font-size:3.5rem;
  }
  @media (max-width: 768px) {
    font-size:1.25rem;/*20px */
  }
`;

const RightSection = styled('div')`
  width: 50%; 
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center; 
`;

const Illustration = styled('img')`
  width: 100%;
  height: auto; 
  object-fit: contain; 
  @media (max-width: 768px) {
    margin-right: 50px;
  }
`;

const MainSection = () => {
  return (
    <Container>
      <LeftSection>
        <BackgroundImage src={leftImage} alt="Privacy Background" />
        <Title>Privacy Policy</Title>
      </LeftSection>

      <RightSection>
        <Illustration src={rightImage} alt="Privacy Illustration" />
      </RightSection>
    </Container>
  );
};

export default MainSection;
